export default [
  {
    path: "branding",
    name: "branding",
    component: () => import("@/views/adminPanel/pages/branding/Branding.vue"),
    meta: {
      rule: "editor",
    },
  },
];
